import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './LoadingBar.pcss';

import {CustomPropShapes, CustomPropTypes, widths} from '../../constants';

class LoadingBar extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        color: CustomPropTypes.color,
        hasPlaceholder: PropTypes.bool,
        width: CustomPropShapes.oneOfConstant(widths),
        percent: PropTypes.number,
        visible: PropTypes.bool,
        foregroundClass: PropTypes.string
    };

    static defaultProps = {
        visible: true,
        width: widths.FULL,
        hasPlaceholder: false
    };

    render() {
        const {
            className,
            color,
            width,
            percent,
            visible,
            hasPlaceholder,
            foregroundClass
        } = this.props;

        const hasPercentage = typeof percent === 'number' && !Number.isNaN(percent);

        const foregroundClasses = cx(styles.bar, foregroundClass, {
            [styles.foregroundDefaultBg]: !foregroundClass,
            [styles.foregroundSolid]: hasPercentage,
            [styles.foregroundIndeterminate]: !hasPercentage,
            [styles.foregroundInvisible]: !visible
        });

        const foregroundStyle = {
            ...(hasPercentage ? {width: `${percent.toFixed(3)}%`} : undefined),
            ...(color ? {backgroundColor: color} : undefined)
        };

        const wrapperClasses = cx(styles.main, styles[width], className, {
            [styles.background]: hasPlaceholder
        });

        return (
            <div className={wrapperClasses}>
                <div className={foregroundClasses} style={foregroundStyle} />
            </div>
        );
    }
}

export default LoadingBar;
